
import { Download } from "@mui/icons-material";
import { useGeneralAppStore } from "../../store/generalAppStore";
import { useRifaStore } from "../../store/rifaStore";
import Modal from "../Modal";
import ModalCustom from "../ModalCustom";
import useWindowSize from "../../hooks/sizeWindow";
import { Alert } from "react-bootstrap";
import { sendRespuesta } from "../../screens/Rifa/handler";
import Loading from "../Loading";
import { useState } from "react";
import { Link } from "react-router-dom";

const ModalDatosSolicitante = ({ getValues, handleSubmit
    , rta, setRta, data, setErrorPrecio, reset, precio,
    setLinkPago, linkPago

}) => {

    const [loading, setLoading] = useState(false);
    const datos = getValues();
    // console.log(datos)
    const { modals, handlerModal } = useGeneralAppStore()
    const { solicitud } = useRifaStore();
    const size = useWindowSize();
    let { width, height } = size;
    // console.log(size)

    return (
        <>
            <ModalCustom
                show={modals.includes('datos-solicitante')}
                size={"lg"}
                padding={0}
                onHide={() => {handlerModal({ modal: false, modalName: "datos-solicitante" }); setLinkPago(null)}}
                title={() => "Datos solicitante"}
                bg={"#E2CFF4"}
                bgHeader={"#1976D2"}
                colorHeader={"#fff"}
            >
                <>
                    <section style={{ color: "#742ABE" }} className="bgModal py-4 px-3 position-relative">

                        {
                            loading &&
                            <div className="position-absolute w-100 h-100 " style={{ background: "rgba(1,1,1,0.8)", zIndex: "99999", top: 0 }}>
                                <Loading time={100} variant={2} />
                            </div>
                        }


                        <p className="mb-3 text-center" style={{ fontSize: width < 576 ? "16px" : "20px", color: "#52089C" }}>Datos ingresados para la compra de la rifa:</p>

                        <ul className="bg-white ps-5 pe-4 py-3 rounded " style={{ border: "4px solid #742ABE", fontSize: width < 576 ? "12px" : "16px" }}>
                            <li className="mb-2"><p>Nombre completo: <span style={{ color: "#FF38BA" }}>{datos.nombre_completo}</span></p></li>
                            <li className="mb-2"><p>Documento: <span style={{ color: "#FF38BA" }}>{datos.dni}</span></p></li>
                            <li className="mb-2"><p>Dirección: <span style={{ color: "#FF38BA" }}>{datos.domicilio}</span></p></li>
                            <li className="mb-2"><p>Email: <span style={{ color: "#FF38BA" }}>{datos.email}</span></p></li>
                            <li className="mb-2"><p>Teléfono: <span style={{ color: "#FF38BA" }}>{datos.telefono}</span></p></li>
                            <li className="mb-2"><p>Cantidad rifas: <span style={{ color: "#FF38BA" }}>{datos.cantidad}</span></p></li>
                            {/* <li><p style={{ color: "#FF38BA" }}>Total: <span>${datos.cantidad * datos.precio}</span></p></li> */}

                        </ul>

                        <p className="col-12 col-md-6 text-center  rounded px-2 py-1 m-0" style={{ fontSize: width < 576 ? "10px" : "14px" , color:"white", background:"#742ABE"}} >Recordatorio: Debé verificar que los datos que ingreso sean correctos</p>
                        <div>
                            {
                                linkPago ?
                                    <button className="py-1 px-4 mt-4" style={{ fontSize: "1rem", boxShadow: "none", border: "none", backgroundColor: "#F63ED3", }}>
                                        <Link to={linkPago} target="__blank" className="" style={{ color: "white" }}>PAGAR</Link>
                                    </button>
                                    :
                                    <button onClick={() => { sendRespuesta(rta, setRta, { ...data, precio: precio }, setErrorPrecio, reset, handlerModal, setLoading, setLinkPago); }} className="py-1 px-4 mt-4 text-white" style={{ fontSize: "1rem", boxShadow: "none", border: "none" }} >PAGAR</button>
                            }
                            <button onClick={() => { reset(), handlerModal({ modal: false, modalName: 'datos-solicitante' }) , setLinkPago(null)}} className="py-1 px-4 mt-4" style={{ fontSize: "1rem", boxShadow: "none", border: "none", backgroundColor: "#F28104" }}  >VOLVER</button>

                        </div>

                        {
                            linkPago &&
                            <div className="text-center " style={{ fontSize: "14px" }}>
                                Si su navegador no abre ventanas emergentes automaticamente, por favor haga click nuevamente en <b style={{ color: "#F63ED3" }}>"PAGAR"</b>
                            </div>
                        }
                        {/* <button type="submit" className="py-1 px-4" style={{ fontSize: "1rem", boxShadow: "none", border: "none" }}>PAGAR</button> */}
                    </section>

                </>
            </ModalCustom>
        </>
    );
}
export default ModalDatosSolicitante;